import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { site } from "../config/site";

export const Footer = ({ onManageCookies }) => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-bordeaux text-cream" data-testid="site-footer">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Logo variant="light" />
          <p className="mt-4 text-sm text-cream/80 leading-relaxed">
            Restaurant de cuisine tunisienne authentique et traiteur événementiel à Sainte-Savine, près de Troyes.
          </p>
        </div>
        <div>
          <h2 className="font-display text-lg font-semibold mb-4">Contact</h2>
          <ul className="space-y-3 text-sm text-cream/85">
            <li className="flex gap-2">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-gold" strokeWidth={1.5} />
              <span>{site.address.full}</span>
            </li>
            <li className="flex gap-2">
              <Phone className="h-4 w-4 mt-0.5 shrink-0 text-gold" strokeWidth={1.5} />
              <a href={site.phoneHref} data-testid="footer-phone" className="hover:text-gold transition-colors">{site.phone}</a>
            </li>
            <li className="flex gap-2">
              <Mail className="h-4 w-4 mt-0.5 shrink-0 text-gold" strokeWidth={1.5} />
              <a href={`mailto:${site.email}`} data-testid="footer-email" className="hover:text-gold transition-colors">{site.email}</a>
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-display text-lg font-semibold mb-4">Horaires</h2>
          <ul className="space-y-3 text-sm text-cream/85">
            <li className="flex gap-2">
              <Clock className="h-4 w-4 mt-0.5 shrink-0 text-gold" strokeWidth={1.5} />
              <span><strong className="text-cream">Restaurant :</strong> {site.hours.restaurant}</span>
            </li>
            <li className="flex gap-2">
              <Clock className="h-4 w-4 mt-0.5 shrink-0 text-gold" strokeWidth={1.5} />
              <span><strong className="text-cream">Traiteur :</strong> {site.hours.traiteur}</span>
            </li>
          </ul>
        </div>
        <div>
          <h2 className="font-display text-lg font-semibold mb-4">Informations légales</h2>
          <ul className="space-y-2 text-sm text-cream/85">
            <li><Link to="/mentions-legales" data-testid="footer-mentions-legales" className="hover:text-gold transition-colors">Mentions légales</Link></li>
            <li><Link to="/conditions-generales-de-vente" data-testid="footer-cgv" className="hover:text-gold transition-colors">Conditions générales de vente</Link></li>
            <li><Link to="/conditions-generales-utilisation" data-testid="footer-cgu" className="hover:text-gold transition-colors">Conditions générales d'utilisation</Link></li>
            <li><Link to="/politique-de-confidentialite" data-testid="footer-confidentialite" className="hover:text-gold transition-colors">Politique de confidentialité</Link></li>
            <li>
              <button type="button" data-testid="footer-manage-cookies" onClick={onManageCookies} className="hover:text-gold transition-colors underline underline-offset-4">
                Gérer mes cookies
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/15">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-6 text-xs text-cream/70 space-y-2">
          <p>
            TN FOOD — SAS au capital de {site.capital} — {site.rcs} — SIRET {site.siret} — TVA {site.tvaIntra}
          </p>
          <p data-testid="footer-allergens">{site.allergenNotice}</p>
          <p>© {year} TN FOOD. Tous droits réservés. Site hébergé par Namecheap.</p>
        </div>
      </div>
    </footer>
  );
};
